export const LOGIN_STATES = Object.freeze({
  LOADING:"loading",
  LOGGEDIN:"loggedIn",
  LOGGEDOUT:"loggedOut"
})
